import { Button } from "@/components/ui/button";
import { Plus, Ship } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { UnitSelector } from "@/components/checkout/UnitSelector";
import { showSuccessToast } from "@/lib/toast-utils";
import { useCart } from "@/contexts/CartContext";

interface AddUnitModalProps {
  trigger?: React.ReactNode;
  tooltipLabel?: string;
}

export function AddUnitModal({ trigger, tooltipLabel }: AddUnitModalProps) {
  const { updateCartVin } = useCart();

  const handleUnitSelected = async (vin: any) => {
    const success = await updateCartVin(vin.vin);
    if (success) {
      showSuccessToast(`${vin.modelYear} ${vin.make} ${vin.model} - HIN: ${vin.vin}`, "HIN Added Successfully");
    }
  };

  const defaultTrigger = (
    <Button variant="ghost" size="icon-lg" className="smooth-hover relative group">
      <Ship className="h-4 w-4 transition-all duration-300 group-hover:opacity-0 group-hover:scale-75" />
      <Plus className="h-4 w-4 absolute inset-0 m-auto opacity-0 scale-75 transition-all duration-300 group-hover:opacity-100 group-hover:scale-100" />
      <span className="sr-only">Add HIN</span>
    </Button>
  );

  return (
    <Tooltip>
      <UnitSelector
        trigger={
          <TooltipTrigger asChild>
            {trigger || defaultTrigger}
          </TooltipTrigger>
        }
        onUnitSelected={handleUnitSelected}
      />
      <TooltipContent side="top">
        <p>{tooltipLabel || 'Add HIN'}</p>
      </TooltipContent>
    </Tooltip>
  );
}
